module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 55
// module chunks = 0